import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getCurrentChartData: {
    loading: false,
    error: null,
    data: null,
  },
  getKilloWattDifference: {
    loading: false,
    error: null,
    data: null,
  },
  getDryerLineChart: {
    loading: false,
    error: null,
    data: null,
  },
  getLiftLogicChart: {
    loading: false,
    error: null,
    data: null,
  },
  getQD01Chart: {
    loading: false,
    error: null,
    data: null,
  },
  getQD02Chart: {
    loading: false,
    error: null,
    data: null,
  },
  energyCost: {
    loading: false,
    error: null,
    data: null,
  },
};

const authSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    getCurrentChartDataStart: (state) => {
      state.getCurrentChartData.loading = true;
      state.getCurrentChartData.error = null;
      state.getCurrentChartData.data = null;
    },
    getCurrentChartDataSuccess: (state, action) => {
      state.getCurrentChartData.loading = false;
      state.getCurrentChartData.data = action.payload;
      state.getCurrentChartData.error = null;
    },
    getCurrentChartDataFailure: (state, action) => {
      state.getCurrentChartData.loading = false;
      state.getCurrentChartData.error = action.payload;
      state.getCurrentChartData.data = null;
    },
    getCurrentChartDataResetForm: (state, action) => {
      state.getCurrentChartData.loading = false;
      state.getCurrentChartData.error = null;
      state.getCurrentChartData.data = null;
    },

    getKilloWattDifferenceStart: (state) => {
      state.getKilloWattDifference.loading = true;
      state.getKilloWattDifference.error = null;
      state.getKilloWattDifference.data = null;
    },
    getKilloWattDifferenceSuccess: (state, action) => {
      state.getKilloWattDifference.loading = false;
      state.getKilloWattDifference.data = action.payload;
      state.getKilloWattDifference.error = null;
    },
    getKilloWattDifferenceFailure: (state, action) => {
      state.getKilloWattDifference.loading = false;
      state.getKilloWattDifference.error = action.payload;
      state.getKilloWattDifference.data = null;
    },
    getKilloWattDifferenceResetForm: (state, action) => {
      state.getKilloWattDifference.loading = false;
      state.getKilloWattDifference.error = null;
      state.getKilloWattDifference.data = null;
    },

    energyCostStart: (state) => {
      state.energyCost.loading = true;
      state.energyCost.error = null;
      state.energyCost.data = null;
    },
    energyCostSuccess: (state, action) => {
      state.energyCost.loading = false;
      state.energyCost.data = action.payload;
      state.energyCost.error = null;
    },
    energyCostFailure: (state, action) => {
      state.energyCost.loading = false;
      state.energyCost.error = action.payload;
      state.energyCost.data = null;
    },
    energyCostResetForm: (state, action) => {
      state.energyCost.loading = false;
      state.energyCost.error = null;
      state.energyCost.data = null;
    },

    getDryerLineChartStart: (state) => {
      state.getDryerLineChart.loading = true;
      state.getDryerLineChart.error = null;
      state.getDryerLineChart.data = null;
    },
    getDryerLineChartSuccess: (state, action) => {
      state.getDryerLineChart.loading = false;
      state.getDryerLineChart.data = action.payload;
      state.getDryerLineChart.error = null;
    },
    getDryerLineChartFailure: (state, action) => {
      state.getDryerLineChart.loading = false;
      state.getDryerLineChart.error = action.payload;
      state.getDryerLineChart.data = null;
    },
    getDryerLineChartResetForm: (state, action) => {
      state.getDryerLineChart.loading = false;
      state.getDryerLineChart.error = null;
      state.getDryerLineChart.data = null;
    },

    getLiftLogicChartStart: (state) => {
      state.getLiftLogicChart.loading = true;
      state.getLiftLogicChart.error = null;
      state.getLiftLogicChart.data = null;
    },
    getLiftLogicChartSuccess: (state, action) => {
      state.getLiftLogicChart.loading = false;
      state.getLiftLogicChart.data = action.payload;
      state.getLiftLogicChart.error = null;
    },
    getLiftLogicChartFailure: (state, action) => {
      state.getLiftLogicChart.loading = false;
      state.getLiftLogicChart.error = action.payload;
      state.getLiftLogicChart.data = null;
    },
    getLiftLogicChartResetForm: (state, action) => {
      state.getLiftLogicChart.loading = false;
      state.getLiftLogicChart.error = null;
      state.getLiftLogicChart.data = null;
    },

    getQD01ChartStart: (state) => {
      state.getQD01Chart.loading = true;
      state.getQD01Chart.error = null;
      state.getQD01Chart.data = null;
    },
    getQD01ChartSuccess: (state, action) => {
      state.getQD01Chart.loading = false;
      state.getQD01Chart.data = action.payload;
      state.getQD01Chart.error = null;
    },
    getQD01ChartFailure: (state, action) => {
      state.getQD01Chart.loading = false;
      state.getQD01Chart.error = action.payload;
      state.getQD01Chart.data = null;
    },
    getQD01ChartResetForm: (state, action) => {
      state.getQD01Chart.loading = false;
      state.getQD01Chart.error = null;
      state.getQD01Chart.data = null;
    },

    getQD02ChartStart: (state) => {
      state.getQD02Chart.loading = true;
      state.getQD02Chart.error = null;
      state.getQD02Chart.data = null;
    },
    getQD02ChartSuccess: (state, action) => {
      state.getQD02Chart.loading = false;
      state.getQD02Chart.data = action.payload;
      state.getQD02Chart.error = null;
    },
    getQD02ChartFailure: (state, action) => {
      state.getQD02Chart.loading = false;
      state.getQD02Chart.error = action.payload;
      state.getQD02Chart.data = null;
    },
    getQD02ChartResetForm: (state, action) => {
      state.getQD02Chart.loading = false;
      state.getQD02Chart.error = null;
      state.getQD02Chart.data = null;
    },
  },
});

export const {
  getCurrentChartDataFailure,
  getCurrentChartDataSuccess,
  getCurrentChartDataStart,

  getCurrentChartDataResetForm,
  getKilloWattDifferenceStart,
  getKilloWattDifferenceSuccess,
  getKilloWattDifferenceFailure,
  getKilloWattDifferenceResetForm,

  getDryerLineChartStart,
  getDryerLineChartSuccess,
  getDryerLineChartResetForm,
  getDryerLineChartFailure,

  getLiftLogicChartStart,
  getLiftLogicChartSuccess,
  getLiftLogicChartResetForm,
  getLiftLogicChartFailure,

  getQD01ChartStart,
  getQD01ChartSuccess,
  getQD01ChartResetForm,
  getQD01ChartFailure,

  getQD02ChartStart,
  getQD02ChartSuccess,
  getQD02ChartResetForm,
  getQD02ChartFailure,
  
  energyCostStart,
  energyCostSuccess,
  energyCostFailure,
  energyCostResetForm,

} = authSlice.actions;

export default authSlice.reducer;
